import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { useStyle } from "./style";
import { Box } from "@mui/material";

interface IParams {
    expand: boolean;
    footerBackgroundColor?: string;
    setExpand: React.Dispatch<React.SetStateAction<boolean>>;
}

export const CardExpandButton = (props: IParams) => {
    const { expand, footerBackgroundColor, setExpand } = props;
    const { classes } = useStyle({ expand, footerBackgroundColor });

    const ExpandIcon = expand ? ExpandLess : ExpandMore;

    return (
        <>
            <Box className={classes.expandButtonDecoration} />
            <button className={classes.expandButtonContainer} onClick={() => setExpand((oldExpand) => !oldExpand)}>
                <ExpandIcon className={classes.expandButtonIcon} fontSize="large" />
            </button>
        </>
    );
};
